import debounce from 'debounce-promise';
import { useFormikContext } from 'formik';
import moment from 'moment';
import React, { useCallback, useEffect, useRef, useState } from 'react';

const AutoSave = ({ debounceMs, showLastSaveMessage = false }) => {
  const didMount = useRef(false);
  const formik = useFormikContext();
  const [lastSaved, setLastSaved] = useState();
  const debouncedSubmit = useCallback(
    debounce(
      () => formik.submitForm().then(() => setLastSaved(moment().format('lll'))),
      debounceMs
    ),
    [debounceMs, formik.submitForm]
  );

  useEffect(() => {
    // to prevent from saving on load, check that page has been loaded
    if (didMount.current) {
      debouncedSubmit();
    } else {
      didMount.current = true;
    }
  }, [debouncedSubmit, formik.values]);

  return (
    <>
      {!showLastSaveMessage
        ? null
        : formik.isSubmitting
        ? 'Saving...'
        : lastSaved !== null
        ? `Last Saved: ${lastSaved}`
        : null}
    </>
  );
};

export default AutoSave;
